const spacing = {
  none: 0,
  xxxs: 6,
  tiny: 7,
  xxs: 8,
  xs: 12,
  s: 16,
  sPlus: 17,
  sm: 20,
  m: 24,
  l: 32,
  xl: 50,
};

export default spacing;
